import React from "react";
import contactPhone from "../../assets/images/svg/contactPhone.svg";
import contactEmail from "../../assets/images/svg/contactEmail.svg";
import CardContact from "../CardContact/CardContact";
import NoImage from "../NoImage/NoImage";
import { connectoRoles } from "../../utils/constants";

const ContactPersonFullCard = ({
  photo,
  name,
  position,
  emailId,
  phoneNum,
}) => {
  return (
    <div className="person_full_card_outside">
      {photo ? (
        <img className="persons_img" src={photo} alt="personPhoto" />
      ) : (
        <NoImage
          data={name?.split(" ")[0][0]}
          noImageClass={"no_image_connect_big_card"}
        />
      )}

      <div className="person_full_card_details">
        <div className="person_details">
          <h2 className="contact_name">{name}</h2>
          <p className="contact_position blueTextColor">
            {connectoRoles[position]}
          </p>
        </div>
        <div className="phone_details blueTextColor">
          <CardContact photo={contactPhone} type={"phone"} content={phoneNum} />
        </div>
        <div className="email_details blueTextColor">
          <CardContact photo={contactEmail} type={"email"} content={emailId} />
        </div>
      </div>
    </div>
  );
};

export default ContactPersonFullCard;
